export var WindowsEVOnboardingSteps;
(function (WindowsEVOnboardingSteps) {
    WindowsEVOnboardingSteps["hasBeenVerified"] = "hasBeenVerified";
    WindowsEVOnboardingSteps["hasChosenProvider"] = "hasChosenProvider";
    WindowsEVOnboardingSteps["hasGeneratedCert"] = "hasGeneratedCert";
    WindowsEVOnboardingSteps["hasOrderedCert"] = "hasOrderedCert";
    WindowsEVOnboardingSteps["hasUploadedCert"] = "hasUploadedCert";
})(WindowsEVOnboardingSteps || (WindowsEVOnboardingSteps = {}));
export var WindowsEVOnboardingProvider;
(function (WindowsEVOnboardingProvider) {
    WindowsEVOnboardingProvider["globalsign"] = "globalsign";
    WindowsEVOnboardingProvider["other"] = "other";
})(WindowsEVOnboardingProvider || (WindowsEVOnboardingProvider = {}));
export var WindowsHSMCertType;
(function (WindowsHSMCertType) {
    WindowsHSMCertType["azureTrustedSigning"] = "azureTrustedSigning";
    WindowsHSMCertType["ev"] = "ev";
    WindowsHSMCertType["file"] = "file";
})(WindowsHSMCertType || (WindowsHSMCertType = {}));
